<template>
    <h3> E-Sign Completed</h3>
    </template>
    <script>
    export default {
        components:{
    
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data: () => ({
    
        }),
        props:{
    
        },
        methods:{
    
        },
        mounted(){
            const dataToSend = { message: 'Hello from the child window!', closePopup:true};
            window.postMessage(dataToSend, window.location.origin);
            // setTimeout(()=>{
                
            // },1000)
        }
    }
    
    </script>